/*
 * Homepage site banner. Fetches config from the admin app and renders it
 * above the sticky header, offsetting the header downward so the banner
 * stays visible. Tears itself out when disabled or empty.
 *
 * The heavy lifting with .shopify-section-header-sticky / .shopify-section-header
 * mirrors the old hard-coded passover banner — that pattern is known to work
 * with both overlay and non-overlay header modes.
 */
(function () {
  var el = document.getElementById('site-banner');
  if (!el) return;

  var apiUrl = el.getAttribute('data-admin-api-url') || '';
  var locale = (el.getAttribute('data-locale') || 'en').toLowerCase();

  if (!apiUrl) {
    el.remove();
    return;
  }

  function teardown() {
    var style = document.getElementById('site-banner-header-offset');
    if (style) style.remove();
    el.remove();
  }

  // A background/outline is either a named palette key — rendered by the
  // CSS classes below — or an explicit '#rrggbb' (admin migration 118), which
  // has no class to add and is applied as inline --sb-* variables instead.
  // Text flips light/dark by luminance, the same rule the admin preview and
  // the catering widget apply. A custom outline is a flat colour, so the gold
  // shimmer animation is switched off with it.
  var HEX_COLOR_RE = /^#[0-9a-f]{6}$/i;

  function hexLuma(hex) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  }

  // The admin's banner height (migration 119) is the DESKTOP height in px;
  // the CSS steps it down for narrower screens and treats it as a minimum, so
  // wrapped text still grows the banner. Null/absent means "whatever the theme
  // says" — an admin that predates the column, or a banner nobody has resized
  // — and out-of-range junk is treated the same way rather than trusted.
  function applyHeight(height) {
    var px = Number(height);
    if (!isFinite(px) || px < 48 || px > 220) return;
    el.style.setProperty('--sb-height', px + 'px');
  }

  function applyTheme(bg, outline) {
    if (HEX_COLOR_RE.test(bg)) {
      el.style.setProperty('--sb-bg', bg.toLowerCase());
      el.style.setProperty('--sb-text', hexLuma(bg) < 0.6 ? '#ffffff' : '#262523');
    } else {
      el.classList.add('site-banner--bg-' + bg);
    }
    if (HEX_COLOR_RE.test(outline)) {
      el.style.setProperty('--sb-outline', outline.toLowerCase());
      el.style.setProperty('--sb-outline-animation', 'none');
    } else {
      el.classList.add('site-banner--outline-' + outline);
    }
  }

  function offsetStickyHeader() {
    var h = el.offsetHeight;
    if (!h) return;
    var style = document.getElementById('site-banner-header-offset');
    if (!style) {
      style = document.createElement('style');
      style.id = 'site-banner-header-offset';
      document.head.appendChild(style);
    }
    var hpx = h + 'px';
    // Three cases, all need the same offset:
    //   1. At top of page, overlay header (position: absolute; top: 0) —
    //      without this it'd sit underneath the banner.
    //   2. Sticky header after scroll (position: fixed; top: 0).
    //   3. Mobile header, which is always positioned at top: 0.
    style.textContent =
      '.shopify-section-header.header-overlay { top: ' + hpx + ' !important; }' +
      '.shopify-section-header-sticky { top: ' + hpx + ' !important; }' +
      '@media (max-width: 960px) { .shopify-section-header { top: ' + hpx + ' !important; } }';
  }

  function render(data) {
    if (!data || !data.enabled) {
      teardown();
      return;
    }
    var text = (data.text && (locale === 'fr' ? data.text.fr : data.text.en)) || '';
    text = String(text).trim();
    if (!text) {
      teardown();
      return;
    }

    var link = el.querySelector('.site-banner__link');
    var textEl = el.querySelector('.site-banner__text');
    textEl.textContent = text;

    if (data.link_url) {
      link.setAttribute('href', data.link_url);
      link.classList.add('site-banner__link--clickable');
    } else {
      // No link → render as a plain span (preserve structure for simplicity).
      link.removeAttribute('href');
      link.classList.add('site-banner__link--static');
    }

    applyTheme(data.background || 'dill', data.outline || 'gold');
    applyHeight(data.height);
    el.removeAttribute('hidden');
    el.classList.remove('site-banner--hidden');

    offsetStickyHeader();
    window.addEventListener('resize', offsetStickyHeader);
  }

  fetch(apiUrl, { credentials: 'omit' })
    .then(function (r) { return r.ok ? r.json() : { enabled: false }; })
    .then(render)
    .catch(function () { teardown(); });
})();
